import { NavLink } from "react-router";
import PropTypes from "prop-types";
import { Children, useState } from "react";
import "../../style/import-Chillax.css";
import "../../style/OngletLeft.css";


const OngletLeft = ({
    ongletList = [
        {
            name : "Onglet 1",
            content : <p>Contenu 1</p>,
            id : 0
        },
        {
            name : "Onglet 2",
            content : <p>Contenu 2</p>,
            id : 1
        }
    ],
    defaultOnglet = ongletList[0].id,
}) => {
  const [activeOnglet, setActiveOnglet] = useState(defaultOnglet); // number assign to the id of the active onglet


  return (
    <div className="ongletLeft_content">
        <nav className="ongletLeft_nav">
            <ul className="ongletLeft_navUl">
                {
                    ongletList.map((onglet)=>
                        <li key={onglet.id} className={`ongletLeft_Li ${onglet.id===activeOnglet?`active`:``}`}>
                            <button className="ongletLeft_button" onClick={()=>setActiveOnglet(onglet.id)}>{onglet.name}</button>
                        </li>
                    )
                }
            </ul>
        </nav>
        <div className="ongletLeft_ongletContent">
            {ongletList.find((onglet)=>onglet.id===activeOnglet).content}
        </div>
    </div>
  );
};

OngletLeft.propTypes = {
    connected: PropTypes.bool,
};

export default OngletLeft;